import React from 'react';
import { CardHeader, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getInitials } from '../../../helpers/initialsExtractor';
import { getPlayerDetails } from '../conneqt.helper';
import { ViewConneqtPayload } from '../../../state/reduxRepositories/conneqt/conneqt.interfaces';
import { dateTime } from '../../../time/datetime';
import { Avatar } from '../../../components/avatar/avatar';

interface ReceivedRequestsProps {
  conneqt: ViewConneqtPayload;
}
export function RequestPlayer({ conneqt }: ReceivedRequestsProps) {
  const { t } = useTranslation();
  return (
    <CardHeader
      avatar={
        <Avatar
          title={getInitials(
            getPlayerDetails(conneqt.requestPlayerClues)?.name,
          )}
        />
      }
      title={getPlayerDetails(conneqt.requestPlayerClues)?.name}
      titleTypographyProps={{ variant: 'subtitle2' }}
      subheaderTypographyProps={{ variant: 'subtitle2' }}
      subheader={
        <Typography variant="subtitle2">
          {dateTime.format(
            getPlayerDetails(conneqt.requestPlayerClues)?.dob,
            t('common.datetime.FORMAT_SHORT_DATE'),
          )}
        </Typography>
      }
    />
  );
}
